import { FC, useCallback, useContext, useEffect, useState } from "react";
import { AppLoader } from "../../../components/loading/LoadingOverlay";
import { DatePicker, IconButton, Loader } from "rsuite";
import { formatDate } from "../../../../util/date";
import { FaIcon } from "../../../components/fontawesome/icon";
import { faPlus, faRefresh, faSearch } from "@fortawesome/free-solid-svg-icons";
import { toRelativeCalendar } from "../../../../lib/date";
import { useNavigate } from "react-router-dom";
import { useQuery } from "../../../../hook/query";
import { DateTime } from "luxon";
import { toInteger } from "lodash";
import { useQueryNavigate } from "../../../../hook/navigate";
import { useVisitControlViewModel } from "../../../../viewmodel/control/Visit";
import { VisitControlGroupByRequestData } from "./component/data";
import { UserVisitControl } from "../../../../domain/control/Visit";
import { ByRequestVisitControlModal } from "../components/modal";
import { SearchFormModal } from "../../../components/modal/SearchFormModal";
import { SearchVisitControlInputList } from "./modal/SearchVisitControlInputList";
import AlertModal from "../../../components/modal/AlertModal";
import { UserAuthContext } from "../../../context/UserContext";
import { FormModal } from "../../../components/modal/FormModal";
import {
  NewVisitInputList,
  NewVisitInputSchema,
} from "./component/NewVisitInputList";

export const ByRequestVisitControlGroup: FC<any> = () => {
  const queryTimestamp = useQuery().get("timestamp");
  const initialSelectedTime = queryTimestamp
    ? DateTime.fromMillis(toInteger(queryTimestamp)).toJSDate()
    : new Date();
  const { appUser } = useContext(UserAuthContext);
  const [selection, setSelection] = useState<UserVisitControl | null>(null);

  const [selectedTime, setSelectedTime] = useState(initialSelectedTime);
  const queryNavigate = useQueryNavigate();
  const {
    //fetch
    fetchState,
    fetchVisitControlList,
    onFetchStateReceived,
    visitControlTimestamp,
    visitControlList,
    //refresh
    refreshEvent,
    requestRefreshEvent,
    onRefreshEventCompleted,
    //search
    searchEvent,
    searchState,
    searchResults,
    requestSearchEvent,
    onSearchEventCompleted,
    searchVisit,
    //generate
    toGenerateExcel,
    //alert
    isAlertVisible,
    descriptionAlert,
    setIsAlertVisible,
    createEvent,
    createState,
    createVisitControl,
    onCreateEventCompleted,
    onCreateStateReceived,
    requestCreateEvent,
  } = useVisitControlViewModel();
  const navigate = useNavigate();

  /* eslint-disable */
  useEffect(() => {
    void fetchVisitControlList(selectedTime.getTime());
  }, [selectedTime]);

  useEffect(() => {
    if (fetchState && !fetchState.isLoading()) {
      if (fetchState.isFailed()) {
        window.toast.error(
          "Ocurrió un error al obtener la lista de control de visitas.",
        );
        console.log(fetchState?.error);
      }
      onFetchStateReceived();
    }
  }, [fetchState]);

  useEffect(() => {
    if (refreshEvent) {
      void fetchVisitControlList(selectedTime.getTime(), true);
      onRefreshEventCompleted();
    }
  }, [refreshEvent]);

  const onTableItemSelected = useCallback((item: UserVisitControl) => {
    navigate(
      `/dashboard/visit-control?reference=${encodeURIComponent(
        item.reference,
      )}`,
    );
  }, []);

  const onModalClosed = useCallback(() => {
    setSelection(null);
  }, []);

  /* eslint-enable */

  const loading = fetchState?.loading || createState?.loading || undefined;

  const onTablePreviewActionClicked = useCallback((item: UserVisitControl) => {
    setSelection(item);
  }, []);

  const onCloseAlert = () => {
    setIsAlertVisible(false);
  };
  const onConfirmationAlert = () => {
    setIsAlertVisible(false);
  };

  useEffect(() => {
    if (createState !== null && !createState.loading) {
      if (createState.isSuccess()) {
        window.toast.success("Se ha registrado el nuevo control de visita.");
      } else {
        window.toast.error(createState!.error!.message);
      }
      requestRefreshEvent();
      onCreateStateReceived();
      onCreateEventCompleted();
    }
  }, [createState]);

  return (
    <div className={"w-full h-full flex flex-col p-3 gap-0 overflow-hidden"}>
      <AppLoader isActive={loading} />
      <AlertModal
        onClose={onCloseAlert}
        onConfirmation={onConfirmationAlert}
        visible={isAlertVisible}
        description={descriptionAlert}
      />
      {selection ? (
        <ByRequestVisitControlModal
          visitControl={selection}
          onClose={onModalClosed}
        />
      ) : null}

      <div
        className={
          "flex-none w-full flex flex-row flex-wrap gap-2 p-2 border-b-2 border-neutral-100 overflow-x-hidden items-center justify-between"
        }
      >
        <span className={"text-lg font-normal text-neutral-600 uppercase"}>
          {formatDate(selectedTime)}
        </span>
        <div className={"flex flex-row flex-wrap items-center gap-2"}>
          <div className={"flex flex-row flex-wrap gap-2 items-center z-0"}>
            <span>Seleccionar fecha</span>
            <DatePicker
              value={selectedTime}
              onChange={(newDate) => {
                if (
                  !!newDate &&
                  newDate?.getTime() !== selectedTime.getTime()
                ) {
                  setSelectedTime(newDate);
                  queryNavigate({
                    timestamp: newDate.getTime(),
                  });
                }
              }}
            />
          </div>
          <IconButton
            size={"sm"}
            appearance={"primary"}
            onClick={requestRefreshEvent}
            icon={<FaIcon icon={faRefresh} />}
          >
            Actualizar
          </IconButton>
          {/* {(appUser.isOperator() || appUser.isSupervisor()) && (
            <IconButton
              onClick={requestCreateEvent}
              icon={<FaIcon icon={faPlus} />}
            >
              Nuevo
            </IconButton>
          )} */}
          <IconButton
            size={"sm"}
            appearance={"primary"}
            onClick={requestSearchEvent}
            icon={<FaIcon icon={faSearch} />}
          >
            Buscar
          </IconButton>
        </div>
      </div>

      {searchEvent ? (
        <SearchFormModal
          typeSearchModal="VisitControlSearch"
          onCancel={onSearchEventCompleted}
          visible={true}
          inputList={SearchVisitControlInputList}
          // disabled={fetchListState?.isLoading()}
          title={"Buscar Visitas"}
          // initialValues={{
          //   filter: "driver",
          // }}
          // onOk={(values: any) => {
          //   updateRequestParams({ ...values });
          // }}
          results={searchResults}
          onSearch={searchVisit}
          onGenerate={toGenerateExcel}
        />
      ) : null}

      {!!createEvent && (
        <FormModal
          title={"Nuevo Control de Visitas"}
          inputList={NewVisitInputList}
          visible={true}
          onOk={createVisitControl}
          onCancel={onCreateEventCompleted}
          disabled={false}
          okButtonLoading={createState?.loading}
          model={NewVisitInputSchema}
        />
      )}

      {fetchState?.isLoading() ? (
        <Loader center backdrop size={"sm"} content={"Cargando..."} />
      ) : (
        <div
          className={
            "flex-1 w-full h-full flex justify-center sm:items-center overflow-hidden"
          }
        >
          <div className={"w-full h-full flex flex-col"}>
            {visitControlTimestamp ? (
              <div className={"w-full flex-none p-2"}>
                <p>
                  <span className={"text-neutral-400 uppercase"}>
                    Última actualización:{" "}
                  </span>
                  {toRelativeCalendar(visitControlTimestamp.timestamp, true)}
                </p>
              </div>
            ) : null}
            <div className={"w-full flex-1 overflow-x-hidden"}>
              <VisitControlGroupByRequestData
                onClick={onTableItemSelected}
                onPreview={onTablePreviewActionClicked}
                items={visitControlList}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
